export default [
    {
        title: 'House Pin',
        icon: 'MapPinIcon',
        tagVariant: 'light-warning',
        resource: 'House Pin',
        action: 'read',
        children: [
            {
                title: 'Lists',
                route: 'house-pin-list',
                resource: 'House Pin',
                action: 'read',
            },
            {
                title: 'Add',
                route: 'house-pin-create',
                resource: 'House Pin',
                action: 'create',
            },
        ],
    },
  ]
  